import { useCallback } from 'react';
import { useMasterPlayer } from '../../../../smartLinks/catalog/song/player/useMasterPlayer';

/** A row plays from a little before its line, so the first word is not cut (design s8). */
const LEAD_IN_SEC = 0.5;

/**
 * Plays the master of a song from a lyric line (design s7b: "each row plays the master from its
 * time"). It uses only the public controls of the one master player of the app (`useMasterPlayer`):
 * a song that plays moves to the line; a paused song moves there and plays; a stopped song starts
 * there.
 */
export function useLinePlayer(accountId: number, itemUuid: string) {
  const { status, positionSec, seek, toggle } = useMasterPlayer({ accountId, itemUuid });

  const playFrom = useCallback(
    (startMs: number) => {
      const seconds = Math.max(0, startMs / 1000 - LEAD_IN_SEC);
      seek(seconds);
      if (status === 'paused') {
        toggle();
      }
    },
    [seek, status, toggle]
  );

  return { playFrom, isPlaying: status === 'playing', positionSec };
}
